module.exports = __webpack_public_path__ + "img/Talk Graphic 8.54d15db3.jpg";